import styled from "styled-components";

export const Container = styled.div`
  .complaint-info {
    display: grid;
    grid-template-rows: repeat(3, 1fr);
    grid-template-columns: repeat(5, 1fr);
  }
`;

export const DocumentContainer = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  box-shadow: 0px 0.5rem 2rem rgba(231, 231, 234, 0.4);
  display: flex;
  justify-content: space-between;
  width: 34.8rem;
  .document-name {
    display: flex;
    font-size: 12px;
    font-weight: 500;
    padding: 0rem 1rem 0rem 1rem;
  }
  img {
    cursor: pointer;
  }
`;
